import React from 'react';
import phrasesType from '../../proptypes/phrases';

const PhrasesContext = React.createContext({});

PhrasesContext.Provider.propTypes = {
  value: phrasesType,
};

export default PhrasesContext;
